import {$controller} from "rapid/index";
import {FILE_SIZES} from "../../../constants/file-sizes.constant";
import {COLOR_PICKER_SWATCH_OPTIONS} from "../../../constants/color-picker.constant";
import {isEqual} from "lodash";


class LiveViewController extends $controller {

    constructor($injector, $scope, $photoTransform) {
        "ngInject";
        super($injector);
        this.$scope = $scope;
        this.Math = Math;
        this.pickerOptions = Object.assign({}, COLOR_PICKER_SWATCH_OPTIONS);
        this.photoTransform = $photoTransform;
        this.editScreems = ["filter", "output"];
        this.index = 0;
        this.fileSizes = FILE_SIZES;
    }

    $onInit() {
        this.$scope.$watch(() => this.model, () => {
            if (!this.model) {
                return;
            }
            if (this.model.shouldOutputPhotoMirrored === undefined) {
                this.model.shouldOutputPhotoMirrored = true;
            }
            if (this.model.hideOutputPictureVideo === undefined) {
                this.model.hideOutputPictureVideo = false;
            }
            if (this.model.hideSharingOptions === undefined) {
                this.model.hideSharingOptions = false;
            }
            this.normalizeLiveViewBackgroundModel();
            this.ensureCustomSceneScreenModel();
            this.setIndexValue();
            if (this.model.customLogo && this.model.customLogo.hideDefaultLogo === undefined) {
                this.model.customLogo.hideDefaultLogo = false;
            }
            if (!this.model.customLogo || !this.model.customLogo.elements){
                this.model.customLogo.elements = {
                    doneButton:{
                        x:90,
                        y:90,
                        width:10,
                        height:10,
                        enabled: false
                    },
                    title:{
                        placeholder:"Your image is being created",
                        enabled:false
                    },
                    text:{
                        placeholder:"It may take a few seconds text",
                        enabled: false
                    },
                    logo:{
                        customIcon: this.model.customLogo.file
                    }
                };
            }

        });
        this.$scope.$watch(
            () => this.model && this.model.customLogo && this.model.customLogo.file && this.model.customLogo.file.attachment_file,
            (newVal, oldVal) => {
                if (newVal === oldVal) {
                    return;
                }
                if (newVal) {
                    this.onCustomLogoFileChange();
                } else {
                    this.onCustomLogoFileRemove();
                }
            }
        );
        // Watch screen text enabled/disabled state
        this.$scope.$watch(
            () => this.model && this.model.customLogo && this.model.customLogo.screenText && this.model.customLogo.screenText.enabled,
            (newVal) => {
                this.syncCustomLogoScreenTextEnabled(newVal);
            }
        );

        // Watch screen text title
        this.$scope.$watch(
            () => this.model && this.model.customLogo && this.model.customLogo.screenText && this.model.customLogo.screenText.title,
            (newVal) => {
                this.syncCustomLogoScreenTextTitle(newVal);
            }
        );

        // Watch screen text subText
        this.$scope.$watch(
            () => this.model && this.model.customLogo && this.model.customLogo.screenText && this.model.customLogo.screenText.subText,
            (newVal) => {
                this.syncCustomLogoScreenTextSubText(newVal);
            }
        );
        this.$scope.$watch(() => this.general, () => {
            this.setIndexValue();
        });
        this.$scope.$watch(
            () => this.model && this.model.customSceneScreen && this.model.customSceneScreen.numberOfScenes,
            (newVal, oldVal) => {
                if (newVal === oldVal && oldVal !== undefined) {
                    return;
                }
                this.normalizeCustomScenesCount();
                this.syncCustomSceneTouchPointsCount();
            }
        );
        this.$scope.$watch(
            () => this.model && this.model.customSceneScreen && this.model.customSceneScreen.enabled,
            (enabled) => {
                if (enabled) {
                    this.ensureCustomSceneScreenModel();
                    this.syncCustomSceneTouchPointsCount();
                }
            }
        );
    }

    ensureCustomSceneScreenModel() {
        if (!this.model) {
            return;
        }
        if (!this.model.customSceneScreen) {
            this.model.customSceneScreen = {};
        }
        if (this.model.customSceneScreen.enabled === undefined) {
            this.model.customSceneScreen.enabled = false;
        }
        if (!this.model.customSceneScreen.background || typeof this.model.customSceneScreen.background !== "object") {
            this.model.customSceneScreen.background = {};
        }
        if (!Array.isArray(this.model.customSceneScreen.touchpoints)) {
            this.model.customSceneScreen.touchpoints = [];
        }
        if (this.model.customSceneScreen.numberOfScenes === undefined || this.model.customSceneScreen.numberOfScenes === null) {
            this.model.customSceneScreen.numberOfScenes = 1;
        }
        this.normalizeCustomScenesCount();
        this.syncCustomSceneTouchPointsCount();
    }

    normalizeCustomScenesCount() {
        if (!this.model || !this.model.customSceneScreen) {
            return;
        }
        const numericValue = parseInt(this.model.customSceneScreen.numberOfScenes, 10);
        const normalized = Number.isFinite(numericValue) && numericValue > 0 ? numericValue : 1;
        this.model.customSceneScreen.numberOfScenes = normalized;
    }

    getDefaultCustomSceneTouchPoint(index) {
        const row = Math.floor(index / 4);
        const col = index % 4;
        return {
            scene_index: index + 1,
            scene_title: "",
            width: 20,
            height: 20,
            x: 15 + (col * 22),
            y: 20 + (row * 25),
            angle: 0,
            custom_icon: null,
            customIcon: null
        };
    }

    syncCustomSceneTouchPointsCount() {
        if (!this.model || !this.model.customSceneScreen) {
            return;
        }
        const desiredCount = this.model.customSceneScreen.numberOfScenes;
        const currentTouchPoints = Array.isArray(this.model.customSceneScreen.touchpoints)
            ? this.model.customSceneScreen.touchpoints
            : [];
        const nextTouchPoints = [];

        for (let i = 0; i < desiredCount; i++) {
            const existing = currentTouchPoints[i] || {};
            const defaults = this.getDefaultCustomSceneTouchPoint(i);
            const mergedTouchPoint = {
                ...defaults,
                ...existing,
                scene_index: i + 1
            };
            if (mergedTouchPoint.customIcon && !mergedTouchPoint.custom_icon) {
                mergedTouchPoint.custom_icon = mergedTouchPoint.customIcon;
            } else if (mergedTouchPoint.custom_icon && !mergedTouchPoint.customIcon) {
                mergedTouchPoint.customIcon = mergedTouchPoint.custom_icon;
            }
            nextTouchPoints.push(mergedTouchPoint);
        }
        if (!isEqual(this.model.customSceneScreen.touchpoints, nextTouchPoints)) {
            this.model.customSceneScreen.touchpoints = nextTouchPoints;
        }
    }

    onCustomSceneNumberChange() {
        this.normalizeCustomScenesCount();
        this.syncCustomSceneTouchPointsCount();
    }

    getCustomSceneTouchPoint(index) {
        if (!this.model || !this.model.customSceneScreen || !Array.isArray(this.model.customSceneScreen.touchpoints)) {
            return null;
        }
        return this.model.customSceneScreen.touchpoints[index] || null;
    }

    getCustomSceneTouchPoints() {
        if (!this.model || !this.model.customSceneScreen || !Array.isArray(this.model.customSceneScreen.touchpoints)) {
            return [];
        }
        return this.model.customSceneScreen.touchpoints;
    }

    getCustomSceneAreas() {
        const areas = {};
        if (!this.model || !this.model.customSceneScreen || !Array.isArray(this.model.customSceneScreen.touchpoints)) {
            return areas;
        }
        this.model.customSceneScreen.touchpoints.forEach((touchPoint, index) => {
            const rawIcon = touchPoint.custom_icon || touchPoint.customIcon || null;
            const iconUrl = rawIcon && typeof rawIcon === "object"
                ? (rawIcon.attachment_file || rawIcon.thumbnail_file || null)
                : (typeof rawIcon === "string" ? rawIcon : null);
            const isVideoIcon = iconUrl ? /\.(mp4|mov|webm)$/i.test(iconUrl) : false;
            let custom_icon = null;
            if (rawIcon) {
                if (typeof rawIcon === "object") {
                    if (rawIcon.attachment_file || rawIcon.thumbnail_file) {
                        custom_icon = rawIcon;
                    }
                } else if (typeof rawIcon === "string" && rawIcon.length > 0) {
                    custom_icon = {attachment_file: rawIcon};
                }
            }
            areas[`config${index + 1}`] = {
                width: touchPoint.width || 20,
                height: touchPoint.height || 20,
                x: touchPoint.x || 15,
                y: touchPoint.y || 20,
                angle: touchPoint.angle || 0,
                title: touchPoint.scene_title || "",
                titleBtn: touchPoint.scene_title || "",
                font: "14px",
                custom_icon: custom_icon,
                customIcon: custom_icon,
                trueVideo: isVideoIcon
            };
        });
        return areas;
    }

    getCustomSceneVideoBackground() {
        const bg = this.model && this.model.customSceneScreen ? this.model.customSceneScreen.background : null;
        if (!bg || !bg.attachment_file) {
            return "";
        }
        const file = bg.attachment_file;
        return /\.(mp4|mov|webm)$/i.test(file) ? file : "";
    }

    isCustomSceneScreenEnabled() {
        return !!(this.model && this.model.customSceneScreen && this.model.customSceneScreen.enabled);
    }

    shouldShowSceneSelector() {
        return !!this.showScenes && !this.isCustomSceneScreenEnabled();
    }

    shouldShowFilterSelector() {
        return !!this.showFilter || this.shouldShowSceneSelector();
    }

    onCustomLogoFileChange() {
        if (!this.model || !this.model.customLogo) {
            return;
        }

        const file = this.model.customLogo.file;

        if (!this.model.customLogo.elements) {
            this.model.customLogo.elements = {};
        }

        this.model.customLogo.elements.logo.customIcon = file;
    }

    onCustomLogoFileRemove() {
        if (
            this.model &&
            this.model.customLogo &&
            this.model.customLogo.elements &&
            this.model.customLogo.elements.logo
        ) {
            this.model.customLogo.elements.logo.customIcon = null;
        }
    }

    syncCustomLogoScreenTextEnabled(enabled) {
        if (!this.model || !this.model.customLogo || this.model.customLogo.screenText === undefined) {
            return;
        }
        this.model.customLogo.elements.title.enabled = !!enabled;
        this.model.customLogo.elements.text.enabled = !!enabled;
    }

    syncCustomLogoScreenTextTitle(title) {
        if (!this.model || !this.model.customLogo || this.model.customLogo.screenText === undefined) {
            return;
        }
        this.model.customLogo.elements.title.placeholder = title;
    }

    syncCustomLogoScreenTextSubText(subText) {
        if (!this.model || !this.model.customLogo || this.model.customLogo.screenText === undefined) {
            return;
        }
        this.model.customLogo.elements.text.placeholder = subText;
    }

    setIndexValue() {
        const height = this.model.liveViewMode === "fullscreen" ? this.general.height : this.model.liveViewPreviewSize.height;
        const width = this.model.liveViewMode === "fullscreen" ? this.general.width : this.model.liveViewPreviewSize.width;
        const sizeValue = height < width ? height : width;
        this.index = sizeValue / 310;
    }

    normalizeBackgroundField(value) {
        if (value === null || value === undefined || value === "") {
            return {};
        }
        if (typeof value === "string") {
            return {attachment_file: value};
        }
        if (typeof value === "object") {
            return value;
        }
        return {};
    }

    normalizeLiveViewBackgroundModel() {
        if (!this.model) {
            return;
        }
        this.model.liveViewBackground = this.normalizeBackgroundField(this.model.liveViewBackground);
        if (this.model.filter) {
            this.model.filter.liveViewBackground = this.normalizeBackgroundField(this.model.filter.liveViewBackground);
        }
        if (this.model.output) {
            this.model.output.liveViewBackground = this.normalizeBackgroundField(this.model.output.liveViewBackground);
        }
    }

    getLiveViewBackgroundModel(screen) {
        if (!this.model) {
            return {};
        }
        const isFullscreen = this.model.liveViewMode === "fullscreen";
        const forAllScenes = !!this.model.forAllScenes;

        switch (screen) {
            case "photo":
                return this.model.liveViewBackground;
            case "filter":
                if (forAllScenes || isFullscreen) {
                    return this.model.liveViewBackground;
                }
                return this.model.filter ? this.model.filter.liveViewBackground : {};
            case "output":
                if (isFullscreen || !forAllScenes) {
                    return this.model.output ? this.model.output.liveViewBackground : {};
                }
                return this.model.liveViewBackground;
            default:
                return this.model.liveViewBackground;
        }
    }

    getLiveViewBackgroundAttachment(screen) {
        const source = this.getLiveViewBackgroundModel(screen);
        if (!source || !source.attachment_file) {
            return "";
        }
        const file = source.attachment_file;
        if (/\.(mp4|mov|webm)$/i.test(file)) {
            return "";
        }
        return file;
    }

    isLiveViewVideoAttachment(screen) {
        return !!this.getLiveViewVideoBackground(screen);
    }

    getLiveViewBackgroundForPreview(screen) {
        const attachment = this.getLiveViewBackgroundAttachment(screen);
        return attachment ? JSON.stringify([attachment]) : "[]";
    }

    getLiveViewBackgroundMode(screen) {
        if (!this.model) {
            return "color";
        }
        const isFullscreen = this.model.liveViewMode === "fullscreen";
        const forAllScenes = !!this.model.forAllScenes;

        switch (screen) {
            case "photo":
                return this.model.liveViewBackgroundMode || "color";
            case "filter":
                if (forAllScenes) {
                    return this.model.liveViewBackgroundMode || "color";
                }
                return (this.model.filter && this.model.filter.liveViewBackgroundMode) || "color";
            case "output":
                if (isFullscreen && this.model.output && this.model.output.enabled) {
                    return this.model.output.liveViewBackgroundMode || "color";
                }
                if (forAllScenes && !isFullscreen) {
                    return this.model.liveViewBackgroundMode || "color";
                }
                return (this.model.output && this.model.output.liveViewBackgroundMode) || "color";
            default:
                return "color";
        }
    }

    getLiveViewBackgroundColor(screen) {
        if (!this.model) {
            return "#ffffff";
        }
        const isFullscreen = this.model.liveViewMode === "fullscreen";
        const forAllScenes = !!this.model.forAllScenes;

        switch (screen) {
            case "photo":
                return this.model.liveViewBackgroundColor || "#ffffff";
            case "filter":
                if (forAllScenes) {
                    return this.model.liveViewBackgroundColor || "#ffffff";
                }
                return (this.model.filter && this.model.filter.liveViewBackgroundColor) || "#ffffff";
            case "output":
                if (isFullscreen && this.model.output && this.model.output.enabled
                    && this.model.output.liveViewBackgroundMode === "color") {
                    return this.model.output.liveViewBackgroundColor || "#ffffff";
                }
                if (forAllScenes && !isFullscreen) {
                    return this.model.liveViewBackgroundColor || "#ffffff";
                }
                if (this.model.output && !this.model.output.enabled) {
                    return "#ffffff";
                }
                return (this.model.output && this.model.output.liveViewBackgroundColor) || "#ffffff";
            default:
                return "#ffffff";
        }
    }

    getFileType(file) {
        if (!file || !file.attachment_file || typeof file.attachment_file !== "string") {
            return "";
        }
        const parts = file.attachment_file.split(".");
        return parts[parts.length - 1];
    }

    getLiveViewVideoBackground(screen) {
        const bg = this.getLiveViewBackgroundModel(screen);
        if (!bg || !bg.attachment_file) {
            return "";
        }
        const file = bg.attachment_file;
        return /\.(mp4|mov|webm)$/i.test(file) ? file : "";
    }

    onModeChange() {
        // color picker change handler placeholder
    }

    onGlobalLiveViewBackgroundUploaded({file}) {
        if (file && this.model) {
            this.model.liveViewBackgroundMode = "image";
        }
    }

    onScreenLiveViewBackgroundUploaded({file}, screen) {
        if (file && this.model && this.model[screen]) {
            this.model[screen].liveViewBackgroundMode = "image";
        }
    }

    getCommonElements(obj1, obj2) {
        if (!obj1 || !obj2) {
            return [];
        }
        return {...obj1, ...obj2};
    }

    onResetButtonsValues(){
        if (this.isPortraite) {
            Object.assign(this.model.customButtons, {
                generalUiButtonsSettings:{
                    back: {width: 4.5, height: 4.5, x: 8, y: 7},
                    sharingBackBtn: {width: 3.5, height: 3.5, x: 8, y: 7},
                    capture: {width: 5.5, height: 5.5, x: 92, y: 50},
                    proceed: {width: 5.5, height: 5.5, x: 92, y: 50},
                    email: {width: 5.5, height: 5.5, x: 16.5, y: 88},
                    sms: {width: 3.5, height: 3.5, x: 35, y: 88},
                    print: {width: 3.5, height: 3.5, x: 45, y: 88},
                    done: {width: 6, height: 6, x: 89, y: 92.5},
                    qrCode: {width: 7, height: 7, x: 50, y: 11,text:"Scan me to download",textSize: 12,textColor: "black"},
                    close: {width: 3.5, height: 3.5, x: 5, y: 28},
                    next: {width: 5, height: 5, x: 93, y: 50},
                    closeError: {width: 5, height: 5, x: 93, y: 50},
                },
                captureModeButtonsSettings:{
                    single: {width: 3.5, height: 3.5, x: 8, y: 44},
                    gif: {width: 3.5, height: 3.5, x: 8, y: 49},
                    boomerang: {width: 3.5, height: 3.5, x: 8, y: 55},
                    scene: {scenePopupColor: "#FFF",width: 36, height: 48, x: 50, y: 57},
                    filter: {width: 5, height: 5, x: 8, y: 38},
                }
            });
        } else {
            Object.assign(this.model.customButtons, {
                generalUiButtonsSettings:{
                    back: {width: 6, height: 6, x: 5, y: 7},
                    sharingBackBtn: {width: 6, height: 6, x: 5, y: 7},
                    capture: {width: 10, height: 10, x: 93, y: 50},
                    proceed: {width: 10, height: 10, x: 93, y: 50},
                    email: {width: 6, height: 6, x: 90, y: 40},
                    sms: {width: 6, height: 6, x: 90, y: 50},
                    print: {width: 6, height: 6, x: 90, y: 60},
                    done: {width: 10, height: 10, x: 90, y: 81},
                    qrCode: {width: 6, height: 6, x: 90, y: 30,text:"Scan me to download",textSize: 12,textColor: "black"},
                    close: {width: 6, height: 6, x: 5, y: 28},
                    next: {width: 10, height: 10, x: 93, y: 50},
                    closeError: {width: 10, height: 10, x: 93, y: 50},
                },
                captureModeButtonsSettings:{
                    single: {width: 6, height: 6, x: 5, y: 44},
                    gif: {width: 6, height: 6, x: 5, y: 54},
                    boomerang: {width: 6, height: 6, x: 5, y: 65},
                    scene: {scenePopupColor: "#FFF",width: 36, height: 48, x: 22, y: 46},
                    filter: {width: 6, height: 6, x: 5, y: 33},
                }
            });
        }
    }

}

export default LiveViewController;



// WEBPACK FOOTER //
// ./sources/components/configurations/live-view/live-view.controller.js